import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import * as ReportingRead from '../../Apis/ReportingReadApi';
import * as Actions from './WebinarsActions';
import { forceLoginIfExpired } from '../Utils/RedirectionUtils';

export function* getWebinarsWatcher() {
  yield takeEvery(Actions.GET_WEBINARS_REQUEST, getWebinarsWorker);
}

export function* getWebinarsWorker(action) {
  try {
    let webinarsList = [];
    const { fromTime, toTime } = action.payload;
    const axiosResponse = yield call(ReportingRead.getWebinars, fromTime, toTime);
    webinarsList = [...webinarsList, ...axiosResponse.data];
    yield put({
      type: Actions.GET_WEBINARS_SUCCESS,
      payload: { webinarsList }
    });
  } catch (error) {
    yield put({ type: Actions.GET_WEBINARS_FAILURE, error });
    forceLoginIfExpired(error);
  }
}

export default function* rootSaga() {
  yield all([fork(getWebinarsWatcher)]);
}



// WEBPACK FOOTER //
// ./src/Reducks/Webinars/WebinarsSagas.js